import { Alert, Button } from "flowbite-react";
import { useForm } from "react-hook-form";
import { ADMIN, QUERIES } from "../../config/apiConfig";
import axios from "../../config/axiosInstance";
import { useEffect, useState } from "react";
import { useQuery } from "react-query";
import Input from "../inputs/Input";
import DrawerLoading from "../DrawerLoading";
import SelectInput from "../inputs/SelectInput";
import { normalizeText } from "../../utils/utils";
import CurrencyInput from "../inputs/CurrencyInput";

const EditQueryCustomForm = ({
  categories,
  company,
  fetchQueries,
  onClose,
  isOpen,
  query,
}) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [key, setKey] = useState(0);
  const [error, setError] = useState(null);
  const [fields, setFields] = useState([
    {
      id: 0,
      priority: 1,
      queryId: 0,
      providerId: 0,
    },
  ]);

  const {
    isLoading: isLoadingProviders,
    error: errorProviders,
    data: providers,
    refetch,
  } = useQuery(
    ["providers", company],
    async () => {
      const { data: items } = await axios.get(`${ADMIN.GET_PROVIDERS_ALL}`);
      return items.data;
    },
    { enabled: isOpen }
  );

  const {
    isLoading: isLoadingQueryCustom,
    error: errorQueryCustom,
    data: queryCustom,
  } = useQuery(
    ["queryCustom", query],
    async () => {
      const { data: items } = await axios.get(
        `${ADMIN.GET_QUERY}/${query?.id}`
      );
      return items.data;
    },
    { enabled: isOpen }
  );

  const {
    register,
    getValues,
    handleSubmit,
    reset,
    setValue,
    watch,
    control,
    formState: { errors },
  } = useForm();

  useEffect(() => {
    if (queryCustom) {
      setValue(`query.name`, queryCustom?.name);
      setValue(`query.price`, queryCustom?.price);
      setValue(`query.url`, queryCustom?.url);
      setValue(`query.categoryId`, queryCustom?.categoryId);
      setValue(`query.description`, queryCustom?.description);
      setValue(
        `queryCustomized.parameterType`,
        queryCustom?.QueryCustomized?.parameterType
      );
      setValue(
        `queryCustomized.showAlertsBoard`,
        queryCustom?.QueryCustomized?.showAlertsBoard
      );

      queryCustom?.QueryCustomized?.QueryCustomizedFields?.forEach(
        (customField, index) => {
          setValue(`fields[${index}].priority`, customField?.priority);
          setValue(`fields[${index}].providerId`, customField?.ProviderId);
          setValue(`fields[${index}].queryId`, customField?.QueryId);
          setValue(`fields[${index}].ignoreErrors`, customField?.ignoreErrors);
        }
      );

      setFields(queryCustom?.QueryCustomized?.QueryCustomizedFields);
    }
  }, [queryCustom, isOpen]);

  const onSubmit = async (data) => {
    setIsSubmitting(true);
    setError(null);
    try {
      await axios.put(`${ADMIN.GET_CUSTOMIZED_QUERY}/${query?.id}`, data);

      onClose(false);

      fetchQueries();
      reset();
    } catch (error) {
      setError(error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <form
        className="mb-6 flex flex-col gap-4"
        onSubmit={handleSubmit(onSubmit)}
      >
        <Input
          register={register}
          label="Nome da consulta *"
          name="query.name"
          required={true}
        />
        <Input
          register={register}
          label="Descrição da consulta"
          name="query.description"
        />
        <div className="flex flex-col md:flex-row gap-4 md:gap-2">
          <div className={"flex-1"}>
            <Input
              register={register}
              label="URL amigável *"
              name="query.url"
              required={true}
              disabled={true}
            />
            <small style={{ fontSize: "10px" }}>
              Obs: Não é possivel alterar a url amigável
            </small>
          </div>
          <div className={"flex-1"}>
            <CurrencyInput
              register={register}
              label="Preço da consulta *"
              control={control}
              name="query.price"
              required={true}
            />
          </div>
        </div>

        <div className="flex flex-col md:flex-row gap-4 md:gap-2">
          <SelectInput
            register={register}
            name="query.categoryId"
            label="Categoria da consulta *"
            required={true}
          >
            {categories?.map((category, index) => (
              <option key={index} value={category.id}>
                {category.name}
              </option>
            ))}
          </SelectInput>
          <SelectInput
            register={register}
            name="queryCustomized.parameterType"
            label="Parâmetro da consulta *"
            required={true}
          >
            <option value="CPF">CPF</option>
            <option value="CNPJ">CNPJ</option>
            <option value="CPF/CNPJ">CPF/CNPJ</option>
            <option value="PLACA">Placa</option>
            <option value="PLACA/CHASSI">Placa/Chassi</option>
          </SelectInput>
        </div>

        <div className="flex items-center mb-1">
          <input
            id={`queryCustomized.showAlertsBoard`}
            type="checkbox"
            name={`queryCustomized.showAlertsBoard`}
            {...register(`queryCustomized.showAlertsBoard`)}
            className="w-4 h-4 text-cyan-600 bg-gray-100 border-gray-300 rounded focus:ring-cyan-500 dark:focus:ring-cyan-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
          />
          <label
            htmlFor={`queryCustomized.showAlertsBoard`}
            className="ms-2 text-sm font-medium text-gray-900 dark:text-gray-300"
          >
            Mostrar quadro de avisos na consulta?
          </label>
        </div>

        <div className="border border-gray-300 rounded-md p-2">
          <div className="flex gap-2 justify-between items-center mb-4">
            <div className="font-semibold text-sm">Campos de retorno</div>
            <div className="flex gap-2">
              <button
                onClick={(e) => {
                  e.preventDefault();
                  setFields((prev) => [
                    ...prev,
                    {
                      id: 0,
                      priority: fields.length + 1,
                      queryId: "",
                      providerId: "",
                    },
                  ]);
                }}
                className="rounded-full w-6 h-6 bg-primary text-white flex items-center justify-center shadow-md"
              >
                +
              </button>
              {fields?.length > 1 && (
                <button
                  onClick={(e) => {
                    e.preventDefault();
                    if (fields.length > 0) {
                      const newFields = watch("fields")?.slice(0, -1);
                      setFields(newFields);
                      setValue("fields", newFields);
                    }
                  }}
                  className="rounded-full w-6 h-6 bg-gray-500 text-white flex items-center justify-center shadow-md"
                >
                  -
                </button>
              )}
            </div>
          </div>
          {fields?.map((field, index) => {
            const selectedQuery = providers?.find(
              (q) => q.id === Number(watch(`fields[${index}].queryId`))
            );

            return (
              <div
                className={`mb-5 ${
                  index !== fields?.length - 1 &&
                  `border-b border-gray-200 pb-3`
                } `}
                key={index}
              >
                <div className="flex gap-2 mb-2">
                  <div className="w-52">
                    <SelectInput
                      register={register}
                      name={`fields[${index}].priority`}
                      label="Ordem"
                      required={true}
                    >
                      {Array.from({ length: 10 }).map((_, index) => (
                        <option key={index} value={index + 1}>
                          {index + 1}
                        </option>
                      ))}
                    </SelectInput>
                  </div>
                  <SelectInput
                    register={register}
                    name={`fields[${index}].queryId`}
                    label="Campo *"
                    value={watch(`fields[${index}].queryId`)}
                  >
                    <option value="">Selecione uma consulta</option>
                    {providers
                      ?.filter(
                        (item) =>
                          !item.queryCustomizedId &&
                          watch("query.categoryId") == item.categoryId
                      )
                      .map((query, index) => (
                        <option key={index} value={query.id}>
                          {query.name}
                        </option>
                      ))}
                  </SelectInput>
                  <SelectInput
                    register={register}
                    name={`fields[${index}].providerId`}
                    label="Provedor *"
                    required={true}
                    value={watch(`fields[${index}].providerId`)}
                  >
                    <option value="">Selecione um Provedor</option>
                    {selectedQuery?.associatedProviders?.map((provider) => (
                      <option key={provider.id} value={provider.id}>
                        {provider.name}
                      </option>
                    ))}
                  </SelectInput>
                </div>
                <div className="flex items-center mb-1">
                  <input
                    id={`fields[${index}].ignoreErrors`}
                    type="checkbox"
                    name={`fields[${index}].ignoreErrors`}
                    {...register(`fields[${index}].ignoreErrors`)}
                    className="w-4 h-4 text-cyan-600 bg-gray-100 border-gray-300 rounded focus:ring-cyan-500 dark:focus:ring-cyan-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                  />
                  <label
                    htmlFor={`fields[${index}].ignoreErrors`}
                    className="ms-2 text-sm font-medium text-gray-900 dark:text-gray-300"
                  >
                    Ignorar erro de retorno
                  </label>
                </div>
              </div>
            );
          })}
        </div>

        <Button
          className="primary"
          type="submit"
          isProcessing={isSubmitting}
          disabled={isSubmitting}
        >
          Atualizar consulta
        </Button>
        {error && (
          <Alert withBorderAccent color="failure">
            Ops! Ocorreu um erro ao tentar atualizar esta consulta. Tente
            novamente mais tarde
          </Alert>
        )}
      </form>

      {(isLoadingQueryCustom || isLoadingProviders) && <DrawerLoading />}
    </>
  );
};

export default EditQueryCustomForm;
